"use client";

import clsx from "clsx";
import { MarketView } from "@/stores/strategiesStore";

interface MarketViewBadgeProps {
  view: MarketView;
}

const viewConfig = {
  long: {
    label: "LONG",
    className: "bg-emerald-500/20 text-emerald-400",
  },
  short: {
    label: "SHORT",
    className: "bg-rose-500/20 text-rose-400",
  },
  neutral: {
    label: "NEUTRAL",
    className: "bg-blue-500/20 text-blue-400",
  },
};

export const MarketViewBadge = ({ view }: MarketViewBadgeProps) => {
  const config = viewConfig[view];

  return (
    <span
      className={clsx(
        "whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold",
        config.className
      )}
    >
      {config.label}
    </span>
  );
};
